<li class="item{{#is_current}} current-post-title{{/is_current}}">
  <a href="{{url}} "class="toc-item-link">
  {{#promo_photo}}
    <div class="toc-promo-img" style="background-image: url({{promo_photo}})"></div>
  {{/promo_photo}}
    <div class="toc-headline">{{title}}</div>
  </a>
</li>
